import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import { Audio } from 'react-loader-spinner'
// import { Rings } from 'react-loader-spinner'
import AlternateTimeline from '../AlternateTimeline'
// import LogoTitle from '../../assets/images/img1.png'
import Logo from './Logo'
import './index.scss'
// import { Image } from 'react-bootstrap'

const Home = () => {
  const [letterClass, setLetterClass] = useState('text-animate');
  const [isLoading, setIsLoading] = useState(true);
  const [spinnerVisible, setSpinnerVisible] = useState(false);
  const [isButtonHovered, setIsButtonHovered] = useState(false);



  const greetArray = ["i", "'m", " ", "J", "o", "e", "y", " ", "B", "o", "n", "n", "e", "v", "i", "l", "l", "e", '.']
  // const greetArray = ["i", "'m", " ", "J", "o", "e", " ", "H", "u", "t", "c", "h", "i", "n", "s", '.']
  const jobArray = [
    'F',
    'r',
    'o',
    'n',
    't',
    ' ',
    'e',
    'n',
    'd',
    ' ',
    'w',
    'e',
    'b',    
    ' ',
    'd',
    'e',
    'v',
    'e',
    'l',
    'o',
    'p',
    'e',
    'r',
    '.',
  ]

  // useEffect(() => {
  //   return setTimeout(() => {
  //     setLetterClass('text-animate-hover')
  //   }, 4000)
  // }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 4000)
    // cleanup
    return () => clearTimeout(timer)
  }, []);

  // useEffect(() => {
    // Simulating a loading delay
  //   setTimeout(() => {
  //     setIsLoading(false);
  //   }, 1000);
  // }, []);

  useEffect(() => {
  const timer = setTimeout(() => {
    setIsLoading(false);
  }, 1000);
  // cleanup
  return () => clearTimeout(timer);
}, []);

  useEffect(() => {
    if (isLoading) {
      setSpinnerVisible(true);
    }
  }, [isLoading]);

  return (
    <>
      <div className="container home-page">
        <div className="text-zone">
          <h1>
            <span className={letterClass}>H</span>
            <span className={`${letterClass} _10`}>i</span>
            <span className={`${letterClass} _11`}>,</span>
            <span className={`${letterClass} _12`}> </span>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={greetArray}
              idx={15}
            />
            <br />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={jobArray}
              idx={18}
            />
            <br />
          </h1>
          <h2>Bonneville Artist Development &amp; Design // JavaScript Explorer // Digital Designer </h2>
          <div className="flat-button-wrapper">
            <Link
              to="/projects"
              className="flat-button"
              onMouseEnter={() => setIsButtonHovered(true)}
              onMouseLeave={() => setIsButtonHovered(false)}
            >
              Projects
              <div className="spinner-container">
                {spinnerVisible && (
                  <Audio
                    height="25"
                    width="25"
                    color={isButtonHovered ? "#000000" : "#FFFF00"}
                    ariaLabel="audio-loading"
                    wrapperStyle={{ display: "inline" }}
                    wrapperClass="wrapper-class"
                    visible={true}
                  />
                  // <Rings
                  //   height="20"
                  //   width="20"
                  //     color="#ffd700"
                  //   radius="5"
                  //   wrapperStyle={{ opacity: "0.6", display: "inline" }}
                  //   wrapperClass="wrapper-class"
                  //   visible={true}
                  //   ariaLabel="rings-loading"
                  // />
                )}
              </div>
            </Link>
          </div>
        </div>

        <div className='timeline'>
          <AlternateTimeline />
        </div>
        <Logo />


      </div>
      {/* <Loader type="ball-scale-multiple" class="loader-container" /> */}
      <Loader type="ball-scale-multiple" />
      {/* <Loader type="pacman" /> */}

    </>
  )
}

export default Home
